import { useSelector } from 'react-redux';
import { LiveStreamDestination } from 'types/stream';

import { streamSelectors } from '../../../../store/modules/stream';

const useStreamDestinations = (list: LiveStreamDestination[], streamId: string) => {
  const streamDestinations = useSelector(state => streamSelectors.selectStreamDestinations(state, list));
  const guestDestinations = useSelector(state => streamSelectors.selectGuestDestinations(state, streamId));

  const mappedDestinations = streamDestinations.map(d => ({
    ...d,
    title: d.title || guestDestinations?.[d.id]?.title || '',
    network: d.network || guestDestinations?.[d.id]?.network
  }));

  return mappedDestinations;
};

export default useStreamDestinations;
